import React from 'react';
import I18n from 'i18n-js';
import { get } from 'lodash';
import {
  core_apimessages_NegotiationParty,
  core_apimessages_NegotiationAction as NegotiationAction,
  Listing,
} from '../rql';
import { UserInputOffer, Taxable } from './negotiation_types';
import OfferQuantitySelect from './offer_quantity_select';
import { IUserContext, withUserContext } from '../components/user_context_provider';
import { MoneyInput } from '../components/money_input';

type OfferChangeHandler = (offer: Partial<UserInputOffer>) => void;
export interface IProps extends IUserContext {
  offer: UserInputOffer;
  listing: Listing;
  taxable: Taxable;
  currency: string;
  action: NegotiationAction;
  party: core_apimessages_NegotiationParty;
  onOfferChange: OfferChangeHandler;
  autoFocus?: boolean;
}

function taxHint(taxable: Taxable) {
  if (taxable && taxable.taxIncluded) {
    return ` (${taxable.taxIncludedHint})`;
  }

  return '';
}

function priceLabel(action: NegotiationAction, taxable: Taxable) {
  if (action === NegotiationAction.COUNTER) {
    return `${I18n.t('commons.offers.label.counterPrice')}${taxHint(taxable)}`;
  }

  return `${I18n.t('commons.offers.label.initialPrice')}${taxHint(taxable)}`;
}

function shippingPriceForBuyer(props: IProps) {
  if (props.party === core_apimessages_NegotiationParty.BUYER) {
    const shippingPrice = get(props, 'offer.shippingPrice', '');
    return I18n.t('commons.offers.shippingPrice', { shippingPrice });
  }
}

function moreThanOneInventoriedItem(listing: Listing) {
  return listing.hasInventory && listing.inventory > 1;
}

function userShouldSeeQuantitySelect(
  party: core_apimessages_NegotiationParty,
  lastOfferedQuantity: number) {
  return lastOfferedQuantity > 1 || party === core_apimessages_NegotiationParty.SELLER;
}

function displayQuantitySelect(props: Partial<IProps>) {
  const { action, listing, offer, party } = props;
  return (action === NegotiationAction.COUNTER || action === NegotiationAction.CREATE) &&
    moreThanOneInventoriedItem(listing) &&
    userShouldSeeQuantitySelect(party, offer.quantity);
}

function OfferAmountInputs(props: IProps) {
  const shippingPrice = shippingPriceForBuyer(props);

  return (
    <div className="offers-form__price-row">
      <div className="offers-form__price">
        <MoneyInput
          label={priceLabel(props.action, props.taxable)}
          suffixText={shippingPrice}
          name="offer-price"
          id="offer-price"
          value={props.offer.price}
          currencyCode={props.currency}
          onChange={(evt) => props.onOfferChange({ price: evt.target.value })}
          required
        />
      </div>
      {displayQuantitySelect(props) &&
        <div className="offers-form__qty">
          <OfferQuantitySelect
            inventory={props.listing.inventory}
            party={props.party}
            quantity={props.offer.quantity}
            onQuantityChange={props.onOfferChange}
          />
        </div>
      }
    </div>
  );
}

export default withUserContext(OfferAmountInputs);
